'use client';

import { ReactNode } from 'react';

interface CardProps {
	children: ReactNode;
	className?: string;
	hover?: boolean;
	popular?: boolean;
}

export function Card({ children, className = '', hover = true, popular = false }: CardProps) {
	return (
		<div
			className={`relative rounded-xl border bg-cyber-200/50 p-6 ${
				hover ? 'hover:border-matrix-400/30 hover:shadow-lg hover:shadow-matrix-400/20' : ''
			} ${
				popular ? 'border-matrix-500' : 'border-matrix-900/20'
			} transition-all duration-300 ${className}`}>
			{children}
		</div>
	);
}
